<template>
  <div @click="goPageCheckDetail" class="order-page-check" v-if="show">
    <div class="page-check-left">
      <div class="title">核对签证信息</div>
      <div class="sub-title">签证信息出错会导致无法入境，请对照图例仔细核对。</div>
    </div>

    <div class="page-check-right" >
      <div class="page-check-button" v-if="!order.enable_api">立即核对</div>
    </div>
  </div>
</template>


<script>
import applicantConstants from '@/constants/applicant-constants';

export default {
  name: 'orderPageCheck',
  props: {
    order: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    show() {
      // 商品配置了签证页示例 && 有申请人状态为5（出签成功） && 未核对过
      const hasVisaPage = this.order && this.order.visa_page;
      const hasVisaPass = this.order && this.order.applicant && this.order.applicant.some(ap => ap.applicant_status === applicantConstants.STATUS.handleVisaSuccess_5);
      const isNoCheck = this.order.visa_check_status === 0;

      return hasVisaPage && hasVisaPass && isNoCheck;
    },
  },
  methods: {
    goPageCheckDetail() {
      this.$router.push({
        name: 'orderDetailPageCheck',
        params: { oid: this.order.user_order_id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.order-page-check {
  padding: 16px 40px 16px 20px;
  background: #fff;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  font-size: 16px;
  .page-check-left {
    .title {
      font-weight: 600;
      color: #2F333D;
      line-height: 28px;
      margin-bottom: 8px;
    }
    .sub-title {
      font-size: 12px;
      color: #ff5a60;
      line-height: 16px;
    }
  }
  .page-check-right {
    .page-check-button {
      width: 96px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      background: #5e9be1;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/order-detail/order-page-check.vue